import {
  Thermometer, Sparkles, Image as ImageIcon, PenLine, Eye, Zap, Rabbit, Compass,
  Gem, FlaskConical, Brain, ScanFace, Puzzle, BookOpen, Clapperboard, GraduationCap,
  MonitorPlay, Swords, Flame, ScrollText, Feather, Waypoints, Orbit,
} from "lucide-react";

// Single source of truth for the 6 univers shown as blocks on the homepage
// and expanded on their dedicated /univers/:slug pages.
export const UNIVERS = [
  {
    id: "eveil",
    slug: "l-eveil",
    label: "L'Éveil",
    span: "md:col-span-8 lg:col-span-8",
    layout: "split",
    hue: 45,
    promise: {
      fr: "Comprends ton état d'esprit et réveille ta soif d'apprendre.",
      en: "Understand your state of mind and awaken your thirst to learn.",
      es: "Comprende tu estado de ánimo y despierta tus ganas de aprender.",
      nl: "Begrijp je gemoedstoestand en wek je leergierigheid.",
    },
    tools: [
      { name: "Thermomètre du Mental", anchor: "thermometre-mental", Icon: Thermometer },
      { name: "La Curiosité", anchor: "la-curiosite", Icon: Sparkles },
    ],
  },
  {
    id: "atelier",
    slug: "l-atelier",
    label: "L'Atelier",
    span: "md:col-span-4 lg:col-span-4",
    layout: "stack",
    hue: 28,
    promise: {
      fr: "Forge tes idées : crée des images, affine tes mots, confronte tes pensées.",
      en: "Forge your ideas: create images, refine your words, challenge your thoughts.",
      es: "Forja tus ideas: crea imágenes, pule tus palabras, confronta tus pensamientos.",
      nl: "Smeed je ideeën: maak beelden, verfijn je woorden, daag je gedachten uit.",
    },
    tools: [
      { name: "La Chambre Noire", anchor: "chambre-noire", Icon: ImageIcon },
      { name: "Le Scribe", anchor: "le-scribe", Icon: PenLine },
      { name: "Le Témoin", anchor: "le-temoin", Icon: Eye },
    ],
  },
  {
    id: "exploration",
    slug: "l-exploration",
    label: "L'Exploration",
    span: "md:col-span-5 lg:col-span-5",
    layout: "stack",
    hue: 200,
    promise: {
      fr: "Laisse l'inattendu te guider dans un labyrinthe de jeux et de découvertes.",
      en: "Let the unexpected guide you through a maze of games and discoveries.",
      es: "Deja que lo inesperado te guíe por un laberinto de juegos y descubrimientos.",
      nl: "Laat het onverwachte je leiden door een doolhof van spellen en ontdekkingen.",
    },
    tools: [
      { name: "La Spirale", to: "/spirale", Icon: Orbit, isNew: true },
      { name: "L'Aiguillon", anchor: "l-aiguillon", Icon: Zap },
      { name: "Le Terrier du Lapin", anchor: "terrier-lapin", Icon: Rabbit },
      { name: "La Boussole de l'Inattendu", anchor: "boussole", Icon: Compass, isNew: true },
      { name: "La Chasse au trésor", anchor: "chasse-tresor", Icon: Gem, isNew: true },
      { name: "Le Labo", anchor: "le-labo", Icon: FlaskConical },
      { name: "Le Devineur", anchor: "le-devineur", Icon: Brain },
      { name: "Vrai ou Bluff", anchor: "vrai-bluff", Icon: ScanFace },
      { name: "Jeux de Logique", anchor: "jeux-logique", Icon: Puzzle },
    ],
  },
  {
    id: "bibliotheque",
    slug: "la-bibliotheque",
    label: "La Bibliothèque",
    span: "md:col-span-7 lg:col-span-7",
    layout: "split",
    hue: 265,
    promise: {
      fr: "Un sanctuaire de savoirs distillés pour nourrir ton intellect.",
      en: "A sanctuary of distilled knowledge to nourish your mind.",
      es: "Un santuario de saberes destilados para nutrir tu intelecto.",
      nl: "Een heiligdom van gedistilleerde kennis om je geest te voeden.",
    },
    tools: [
      { name: "Les Lexiques", anchor: "les-lexiques", Icon: BookOpen },
      { name: "Les Capsules", anchor: "les-capsules", Icon: Clapperboard },
      { name: "L'Académie", anchor: "l-academie", Icon: GraduationCap },
    ],
  },
  {
    id: "agora",
    slug: "l-agora",
    label: "L'Agora",
    span: "md:col-span-8 lg:col-span-8",
    layout: "split",
    hue: 12,
    promise: {
      fr: "Échange, débats et grandis avec la communauté autour du feu.",
      en: "Exchange, debate and grow with the community around the fire.",
      es: "Intercambia, debate y crece con la comunidad alrededor del fuego.",
      nl: "Wissel uit, debatteer en groei met de gemeenschap rond het vuur.",
    },
    tools: [
      { name: "Les Conférences", anchor: "les-conferences", Icon: MonitorPlay },
      { name: "Les Débats · L'Arène", anchor: "les-debats", Icon: Swords },
      { name: "Le Feu de camp", anchor: "feu-de-camp", Icon: Flame },
    ],
  },
  {
    id: "adn",
    slug: null, // links directly to existing brand pages
    label: "Notre ADN",
    span: "md:col-span-4 lg:col-span-4",
    layout: "stack",
    hue: 38,
    promise: {
      fr: "Découvre les piliers et la vision qui animent notre démarche anti-scolaire.",
      en: "Discover the pillars and vision behind our anti-school approach.",
      es: "Descubre los pilares y la visión de nuestro enfoque anti-escolar.",
      nl: "Ontdek de pijlers en de visie achter onze anti-school-aanpak.",
    },
    tools: [
      { name: "Le Manifeste", to: "/manifeste", Icon: ScrollText },
      { name: "La Philosophie", to: "/philosophie", Icon: Feather },
      { name: "Le Chemin de soie", to: "/chemin-de-soie", Icon: Waypoints, isNew: true },
    ],
  },
];

export const universBySlug = (slug) => UNIVERS.find((u) => u.slug === slug);
